import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "13",
  height: "10",
  viewBox: "0 0 13 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1 4.5C0.723858 4.5 0.5 4.72386 0.5 5C0.5 5.27614 0.723858 5.5 1 5.5V4.5ZM12.3536 5.35355C12.5488 5.15829 12.5488 4.84171 12.3536 4.64645L9.17157 1.46447C8.97631 1.2692 8.65973 1.2692 8.46447 1.46447C8.2692 1.65973 8.2692 1.97631 8.46447 2.17157L11.2929 5L8.46447 7.82843C8.2692 8.02369 8.2692 8.34027 8.46447 8.53553C8.65973 8.7308 8.97631 8.7308 9.17157 8.53553L12.3536 5.35355ZM1 5.5H12V4.5H1V5.5Z",
      fill: "#212225"
    }, null, -1)
  ])))
}
export default { render: render }